/**
 * 3.0: TRACKS — внутренние дорожки (курсы) внутри направления.
 *
 * Ключевое продуктовое решение: форензика/расследование/доказательства —
 * это НЕ отдельное направление, а сквозная дорожка, прошивающая все:
 *   it-soc/forensics · law-order/evidence · business-law/incident · citizen/trace.
 * Оффенсивные лабы — вторичный трек it-soc/attack («Понимание атакующего»).
 */

export const CORE_TRACK = "core";

export interface TrackDef {
  id: string;
  name: string;
  description: string;
}

export const TRACKS: Record<string, TrackDef[]> = {
  citizen: [
    {
      id: "hygiene",
      name: "Личная цифровая гигиена",
      description: "Аккаунты, пароли, приложения, Wi-Fi — цифровые привычки, которые защищают.",
    },
    {
      id: "scam",
      name: "Фишинг и мошенничество",
      description: "Как работают мошенники — и как не попасться.",
    },
    {
      id: "trace",
      name: "Цифровой след и доказательства",
      description: "Куда уходит ваши данные и как они становятся доказательствами.",
    },
  ],
  "business-law": [
    {
      id: "risk",
      name: "Киберриски бизнеса",
      description: "Данные, поставщики, регуляторика: управление цифровыми рисками компании.",
    },
    {
      id: "incident",
      name: "Расследование инцидентов",
      description: "Первые 24 часа, инсайдеры, аферы: расследование и документирование.",
    },
  ],
  "it-soc": [
    {
      id: "soc",
      name: "Основы SOC",
      description: "Триаж, критичность, повседневная работа центра мониторинга.",
    },
    {
      id: "forensics",
      name: "Цифровая форензика (DFIR)",
      description:
        "Расследование инцидентов: логи, артефакты, доказательства, инцидент-отчёт. Сквозная дорожка платформы.",
    },
    {
      id: "attack",
      name: "Понимание атакующего",
      description:
        "Оффенсивные техники (разведка, эксплуатация) — чтобы понимать атакующего и защищаться.",
    },
  ],
  "law-order": [
    {
      id: "digital-law",
      name: "Цифровое право",
      description:
        "УК РК, личные данные, ИИ, границы мониторинга и тестирования: правовая рамка цифрового мира.",
    },
    {
      id: "evidence",
      name: "Цифровые доказательства в суде",
      description:
        "Цепочка сохранности, допустимость, оформление доказательств. Сквозная дорожка платформы.",
    },
  ],
};

export function trackName(direction: string, track: string): string {
  if (!track || track === CORE_TRACK) return "Базовый курс";
  return TRACKS[direction]?.find((t) => t.id === track)?.name ?? track;
}

export function trackDescription(direction: string, track: string): string {
  if (!track || track === CORE_TRACK) return "";
  return TRACKS[direction]?.find((t) => t.id === track)?.description ?? "";
}
